module.exports = __webpack_public_path__ + "static/img/weather_sunny.0b3110f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather_sunny.png
// module id = cG94
// module chunks = 2